import { Dispatch, FC, SetStateAction } from 'react';
import { useFormContext } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import { Divider, Grid, Stack } from '@mui/material';
import { DatasetCreation } from '~/api/types';
import { modalContainerHeight, modalOverflowBoxStyles } from '~/components/styles';
import { ModalActionBlock } from '.';
import { DataUploadersBlock, PrimaryDataStewardBlock, SecondaryDataStewardBlock } from '..';
import { DatasetCreationStepsEnum } from './types';

interface AddDataMembersStepProps {
  onEdit: (data: DatasetCreation) => Promise<void>;
  onSubmit: (data: DatasetCreation) => Promise<void>;
  setActiveStep: Dispatch<SetStateAction<DatasetCreationStepsEnum>>;
}

const AddDataMembersStep: FC<AddDataMembersStepProps> = ({ onEdit, onSubmit, setActiveStep }) => {
  const datasetId = +useParams().id!;
  const { handleSubmit } = useFormContext();

  return (
    <form onSubmit={handleSubmit(datasetId ? onEdit : onSubmit)}>
      <Stack sx={{ ...modalOverflowBoxStyles, height: `calc(${modalContainerHeight} - 240px)` }}>
        <Grid container spacing={2} alignItems="end">
          <PrimaryDataStewardBlock />
          <SecondaryDataStewardBlock />
          <Grid size={12} p={3}>
            <Divider variant="middle" />
          </Grid>
          <DataUploadersBlock />
        </Grid>
      </Stack>
      <ModalActionBlock activeStep={DatasetCreationStepsEnum.DATA_MEMBERS} setActiveStep={setActiveStep} />
    </form>
  );
};

export default AddDataMembersStep;
